import { Injectable } from '@angular/core';
import { ConnectionService } from './conexion.service';
import { InfoConcat } from './../models/contactpublicity';

@Injectable({
  providedIn: 'root'
})
export class ContactpublicityService {
  collection: string = 'infouser';

  constructor(private connectionServ: ConnectionService) {

  }

  create(info:InfoConcat){
    return this.connectionServ.create(this.collection,info);
  }
}
